// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'spacing-standard';

export const Component = () => (
  <g fill='#D0E0F7' stroke='#4185DE' strokeLinecap='round' strokeLinejoin='round'>
    <rect width='7' height='7' x='.5' y='.5' rx='.5' />
    <rect width='7' height='7' x='10.5' y='.5' rx='.5' />
    <rect width='7' height='7' x='.5' y='10.5' rx='.5' />
    <rect width='7' height='7' x='10.5' y='10.5' rx='.5' />
  </g>
);

export const viewBox = '0 0 18 18';
